module.exports = "<div #panelContainer>\n\n</div>"